import { getQueryFn, useApiQuery } from "../helpers/useApi";
import { apiFetch } from "./fetch";

export type Settings = {
    email?: string;
    phone?: string;
}


export type EnableChannelBody = {
    channelId: number;
    businessHour: number;
    timezone: string;
    settings: Settings;
};

export type UpdateNotificationBody = {
    channelId: number;
    notificationTypeId: number;
    isEnabled: boolean;
};

export type UpdatedPreferencesResponse = {
    companyId: string;
    userId: string;
    updated: [
        {
            channelId: number;
            notificationId: number;
            isEnabled: boolean;
            businessHour: number;
            timezone: string;
        }
    ]
}

export function useNotifications<T>(queryKey: string) {
    return useApiQuery<T>({
        path: `/data/v1/notifications/preferences`,
        body: {}
    }, queryKey)
}

export function enableChannelNotifications(payload: EnableChannelBody, accessToken: string | undefined): Promise<object> {
    return getQueryFn<object>({
        path: `/data/v1/notifications/preferences`,
        body: payload,
        method: 'POST'
    }, (body: unknown = {}, path = '/', method = 'GET',
        endpoint: string | undefined = process.env.REACT_APP_API_GATEWAY,
        authorization: string | undefined = undefined) => apiFetch<object>(path, body, method, endpoint, authorization || `Bearer ${accessToken}`), accessToken)();
}

export function disableChannelNotifications(channelId: number, accessToken: string | undefined): Promise<object> {
    return getQueryFn<object>({
        path: `/data/v1/notifications/preferences?channelId=${channelId}`,
        body: {},
        method: 'DELETE'
    }, (body: unknown = {}, path = '/', method = 'GET',
        endpoint: string | undefined = process.env.REACT_APP_API_GATEWAY,
        authorization: string | undefined = undefined) => apiFetch<object>(path, body, method, endpoint, authorization || `Bearer ${accessToken}`), accessToken)();
}

export function updateNotification<T>(params: UpdateNotificationBody, accessToken: string | undefined) {
    return getQueryFn<object>({
        path: `/data/v1/notifications/preferences`,
        body: params,
        method: 'PUT'
    }, (body: unknown = {}, path = '/', method = 'GET',
        endpoint: string | undefined = process.env.REACT_APP_API_GATEWAY,
        authorization: string | undefined = undefined) => apiFetch<object>(path, body, method, endpoint, authorization || `Bearer ${accessToken}`), accessToken)();
}

